(() => {
  if (window.goldenMateProductCardVariantsInitialized) return;

  window.goldenMateProductCardVariantsInitialized = true;

  const getFetchConfig = () => {
    if (window.theme?.utils?.fetchConfig) {
      const config = window.theme.utils.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      return config;
    }

    return {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      }
    };
  };

  const setFormLoading = (form, isLoading) => {
    const submitButton = form.querySelector('.gm-product-card__cta-shop');

    form.dataset.gmCardSubmitting = isLoading ? 'true' : 'false';

    if (!submitButton) return;

    submitButton.toggleAttribute('aria-busy', isLoading);
    submitButton.toggleAttribute('aria-disabled', isLoading);
  };

  const showFormError = (form, message) => {
    const errorMessage = form.querySelector('.product-form__error-message');

    if (!errorMessage) return;

    errorMessage.textContent = message || '';
    errorMessage.toggleAttribute('hidden', !message);
  };

  const openCartDrawer = async (form, parsedState, variantId) => {
    const cartUrl = window.theme?.routes?.cart_url || window.Shopify?.routes?.root || '/cart';
    const cartResponse = await fetch(cartUrl, { ...(window.theme?.utils?.fetchConfig?.('json', 'GET') || { headers: { Accept: 'application/json' } }) });
    const cartJson = await cartResponse.json();

    if (parsedState?.sections) cartJson.sections = parsedState.sections;

    window.theme?.pubsub?.publish?.(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
      source: 'product-card-form',
      productVariantId: variantId,
      cart: cartJson
    });

    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: { product: parsedState }
    }));

    document.querySelector('cart-drawer')?.show(form.querySelector('.gm-product-card__cta-shop'));
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || !form.matches('.gm-product-card__cta-form')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (form.dataset.gmCardSubmitting === 'true') return;

    const variantId = form.querySelector('[name="id"]')?.value;
    const addUrl = window.theme?.routes?.cart_add_url || '/cart/add';
    const formData = new FormData(form);
    const sectionsToBundle = [];

    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    formData.append('sections', sectionsToBundle);
    formData.append('sections_url', window.location.pathname);

    const config = getFetchConfig();
    config.body = formData;

    setFormLoading(form, true);
    showFormError(form, '');

    try {
      const response = await fetch(addUrl, config);
      const parsedState = await response.json();

      if (parsedState.status) {
        showFormError(form, parsedState.description || parsedState.message);
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: { errorMessage: parsedState.description || parsedState.message }
        }));
        return;
      }

      await openCartDrawer(form, parsedState, variantId);
    } catch (error) {
      console.log(error);
      showFormError(form, 'Cannot add product to cart');
    } finally {
      setFormLoading(form, false);
    }
  }, true);

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const switcher = event.target.closest('[data-gm-card-variant-switch]');

    if (!switcher || switcher.disabled) return;

    const card = switcher.closest('.product-card--spec-rich');
    const swatchItem = switcher.closest('li');

    if (!card || !swatchItem) return;

    card.querySelectorAll('[data-gm-card-variant-switch]').forEach((control) => {
      control.setAttribute('aria-pressed', control === switcher ? 'true' : 'false');
    });

    const priceTemplate = swatchItem.querySelector('[data-gm-card-variant-price]');
    const currentPrice = card.querySelector('.gm-product-card__price');
    const nextPrice = priceTemplate?.content.firstElementChild?.cloneNode(true);

    if (currentPrice && nextPrice) currentPrice.replaceWith(nextPrice);

    const mediaTemplate = swatchItem.querySelector('[data-gm-card-variant-media]');
    const currentImage = card.querySelector('.product-card__media > a.media > img');
    const nextImage = mediaTemplate?.content.querySelector('img')?.cloneNode(true);

    if (currentImage && nextImage) currentImage.replaceWith(nextImage);

    const variantUrl = switcher.dataset.variantUrl;
    if (variantUrl) {
      card.querySelectorAll('[data-gm-card-product-link]').forEach((link) => {
        link.href = variantUrl;
      });
    }

    const addToCartButton = card.querySelector('.gm-product-card__cta-shop');
    const variantIdInput = card.querySelector('.gm-product-card__cta-form [name="id"]');
    const variantId = switcher.dataset.variantId;

    if (variantIdInput && variantId) variantIdInput.value = variantId;
    if (addToCartButton && variantId) addToCartButton.dataset.variantId = variantId;

    card.dataset.selectedVariantId = variantId;
  });
})();
